import { VproService } from 'src/app/service/vpro/vpro.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AllPatient } from '../../models/patient';
import { Physician } from 'src/app/models/physician';
import { Utils } from 'src/app/common/utils';
import moment from 'moment';
@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {
  homePageUrl = Utils.homePageUrl;
  defaultContact = Utils.CONTACT_NO;
  defaultEmail = Utils.SUPPORT_EMAIL;
  dateFormat = Utils.DATE_FORMAT; // default date format from constants
  currentDate = Utils.maxDate;
  public invoice: any;
  public patient: AllPatient;
  public physician: Physician;
  public appointment: any;
  physician_model: any = {};
  specialitiesList: any = [];
  states: any = [];
  constructor(
    private route: ActivatedRoute,
    private vs: VproService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    localStorage.removeItem('onlineAppointment')
    this.route.queryParams.subscribe(params => {
      this.invoice = params;
      if (params.aptid) this.getAppointment(params.aptid);
    });
  }
  getAppointment(id) {
    this.spinner.show();
    this.vs.getAppointmentDetails(
      { aptid: id, fields: ["physician_details", "patient_details"] }).subscribe(res => {
        this.spinner.hide();
        this.appointment = res;
        if (res.patient_details)
          this.patient = res.patient_details;

        if (this.patient && this.patient.dob) {
          let fdate = moment(this.patient.dob).format("MM-YYYY");
          var contractMoment = moment(fdate, 'MM-YYYY');
          let a = moment();
          let age = moment.duration(a.diff(contractMoment));
          let years = age.years();
          let months = age.months();
          if (years > 0)
            this.patient.age = years + " years " + months + " months "
          else
            this.patient.age = months + " months "
        }

        if (res.physician_details) {
          this.physician = res.physician_details;

          if (this.physician && this.physician.physician_qualification && this.physician.physician_qualification.length) {
            if (this.physician.physician_qualification[0].qualification)
              this.physician.qualification = this.physician.physician_qualification[0].qualification;
            if (this.physician.physician_qualification[0].r_no)
              this.physician.r_no = this.physician.physician_qualification[0].r_no;
          }

          if (this.physician && this.physician.physician_speciality && this.physician.physician_speciality.length) {
            this.getSpecialitiesList();
          }

          if (this.physician && this.physician.state) {
            this.loadStates();
          }

          if (this.appointment && this.appointment.aptime) this.appointment.aptime = Utils.formatTime(this.appointment.aptime);

          if (this.invoice) {
            let fdate = moment(this.currentDate).format("DD/MM/YYYY");
            let start = moment(fdate, 'DD/MM/YYYY').toDate();
            // this.invoice.issue_date = moment().format("DD/MM/YYYY");
          }
        }
        this.showMessage('Appointment Booked.', 'success')
      }, err => {
        this.spinner.hide();
        console.log(err);
      })
  }

  getSpecialitiesList() {
    this.spinner.show();
    this.vs.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
        //Map Specialities 
        let specialities = [];
        this.physician.physician_speciality.forEach(element => {
          let sp = this.specialitiesList.find(s => s.id == element.speciality_id)
          specialities.push(`${sp.name}`)
        });
        this.physician_model.speciality = specialities.join(', ');
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadStates() {
    this.vs.getStates(1).subscribe((res) => {
      this.states = res;
      this.physician_model.location = this.states.find(x => x.id == this.physician.state)
      this.physician_model.location = ", " + this.physician_model.location.name.toLowerCase();
    });
  }


  showMessage(message, type) {
    Swal.fire({
      title: message,
      type: type
    })
  }

}
